import React, { createContext, useState } from 'react';

const BookUploadContext = createContext([]);

const BookUploadProvider = ({ children }) => {
	const [data, setData] = useState([]);
	const [generalInfo, setGeneralInfo] = useState({
		area_conhecimento_id: null,
		etapa_id: null,
		etapa: null,
    livro_id: null,
	})
	const handleGeneralChange = (fieldName, value) => {
		setGeneralInfo((prevFormData) => ({
			...prevFormData,
			[fieldName]: value,
		}));
	};

	const handleDataChange = (formIndex, fieldName, value) => {
		setData((prevData) => {
			const updatedForm = { ...prevData[formIndex], [fieldName]: value };
			return prevData.map((form, index) =>
				index === formIndex ? updatedForm : form
			);
		});
	};

	const updateTopic = (formId, topicId, field, value) => {
		setData((prevData) => {
			return prevData.map((form) => {
				if (form.id === formId) {
					const updatedTopics = form.topic.map((topic) => {
						if (topic.id === topicId) {
							return { ...topic, [field]: value };
						}
						return topic;
					});

					return { ...form, topic: updatedTopics };
				}
				return form;
			});
		});
	};


	return (
		<BookUploadContext.Provider value={{ data, setData, generalInfo, setGeneralInfo, handleGeneralChange, handleDataChange, updateTopic }}>
			{children}
		</BookUploadContext.Provider>
	);
};

export { BookUploadContext, BookUploadProvider };
